import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Form, Input, Button, Toast } from 'antd-mobile';
import api, { clearAuth } from '../api';

function ChangePasswordPage() {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const user = JSON.parse(localStorage.getItem('user') || '{}');

  const onFinish = async (values) => {
    if (values.newPassword !== values.confirmPassword) {
      Toast.show({ icon: 'fail', content: 'Пароли не совпадают' });
      return;
    }
    if ((values.newPassword || '').length < 6) {
      Toast.show({ icon: 'fail', content: 'Пароль должен быть не короче 6 символов' });
      return;
    }

    setLoading(true);
    try {
      await api.post('/auth/change-password', {
        employee_id: user.id,
        old_password: values.oldPassword,
        new_password: values.newPassword,
      });
      clearAuth();
      Toast.show({ icon: 'success', content: 'Пароль изменён. Войдите заново.' });
      navigate('/login');
    } catch (err) {
      const detail = err?.response?.data?.detail || 'Не удалось сменить пароль';
      Toast.show({ icon: 'fail', content: detail });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        padding: 24,
        boxSizing: 'border-box',
      }}
    >
      <h2 style={{ marginTop: 32, marginBottom: 8 }}>Смена пароля</h2>
      <div style={{ color: '#666', marginBottom: 24, fontSize: 14, lineHeight: 1.5 }}>
        Для продолжения работы установите новый пароль.
      </div>

      <Form
        form={form}
        layout="vertical"
        onFinish={onFinish}
        footer={
          <Button
            block
            type="button"
            color="primary"
            loading={loading}
            size="large"
            onClick={() => form.submit()}
          >
            Сохранить пароль
          </Button>
        }
      >
        <Form.Item
          name="oldPassword"
          label="Текущий пароль"
          rules={[{ required: true, message: 'Введите текущий пароль' }]}
        >
          <Input type="password" placeholder="Текущий пароль" />
        </Form.Item>

        <Form.Item
          name="newPassword"
          label="Новый пароль"
          rules={[{ required: true, message: 'Введите новый пароль' }]}
        >
          <Input type="password" placeholder="Не менее 6 символов" />
        </Form.Item>

        <Form.Item
          name="confirmPassword"
          label="Повторите новый пароль"
          rules={[{ required: true, message: 'Повторите новый пароль' }]}
        >
          <Input type="password" placeholder="Повторите новый пароль" />
        </Form.Item>
      </Form>
    </div>
  );
}

export default ChangePasswordPage;
